import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";

import { FilterObj } from '../CommonComponents/globalfilterObj';
export default function SerialNumber(props) {
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
  
    const [formObj, setFormObj] = useState(FilterObj);

    const [TypeofShipData, setTypeofShipData] = React.useState([]);

    const fetchTypeofShipData = async () => {
        //
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/Equipments`;

        await getRequest(url)
            .then((res) => {
                console.log("Responce", res);
                if (res.status == 200) {
                   let data = res.data;
                    // result.unshift(obj);
                    let result = data?.map((a, i) => {
                        return { id: a?.machineryUsageType, name: a?.machineryUsageType };
                    });
                    setTypeofShipData(result);
                } else {
                    ToastError(res.data.message);
                }
            })
            .catch((error) => {
                // dispatch({ type: LOADING, payload: false });
                //console.log(error);
                // ToastError(error.response.data.message);
            });
    }
    const handleChange = (event, newValue) => {
        props.onChange(newValue);
        const filteredTypeofShipdata = {
            ...formObj,
            TypeofShipData: newValue
        };
        setFormObj(filteredTypeofShipdata);
    }
    const defaultValue = (val) => {
        //
        if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            console.log('getcookievalue', formObj)
        }else{
            setFormObj({});
        }
    }
    React.useEffect(() => {
        //
        defaultValue(GlobalFilterSettingValue);
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                value={formObj.TypeofShipData || []}
                getOptionSelected={(option, value) => option.name === value.name}
                options={TypeofShipData}
                getOptionLabel={(option) => option.name}
               
                onChange={(event, newValue) => handleChange(event, newValue)}
                
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Type of Ship"
                        placeholder=""
                        onChange={fetchTypeofShipData}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

